import { Component, Input } from '@angular/core';

@Component({
  selector: 'pt-editor-treatment-placeholder',
  template: `
    <div class="placeholder" *ngIf="enabled">
        <div>Loading</div>
        <div class="text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
    </div>
  `,
  styles: [`
    .placeholder {
      display: flex;
      z-index: 100000000;
      position: absolute;
      top:0;
      left:0;
      width: 100%;
      height: 100%;
      background: #33333315;
      border: 1px dashed #33333396;

      align-items: center;
      color: black;
      justify-content: center;
      flex-direction: column;
      min-height: 205px
    }

    .spinner-border {
      width: 22px;
      height: 22px;
      margin-top: 5px;
    }
  `]
})
export class TreatmentEditorPlaceholderComponent {
  @Input() enabled = true;
}
